module.exports = { 
  content: { 
    main: "Welcome to CERESHOP", 
    titleLogin: "Sign In",
    titleRegister: "Sign Up",
    phoneNumber: "Phone Number",
    phoneNumberPlaceholder: "Please enter your phone number",
    verificationCode: "Verification code",
    verificationCodePlaceholder: "Please enter verification code",
    getCode: 'Get code',
    again: 'Again',
    sevenDay: 'Free login for seven days',
    agree: "Read and agree",
    serviceAgreement: "Service Agreement",
  } 
} 


// WEBPACK FOOTER //
// ./src/assets/lang/en-us/login.js